// extracted by mini-css-extract-plugin
export default {"backHeader":"BackHeader_backHeader__fPoP6","headerContent":"BackHeader_headerContent__X3yVt","button":"BackHeader_button__Pz20-","text":"BackHeader_text__KLvnO"};